import "./App.css";
import LoAForm from "./components/LoAForm";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <LoAForm />
      </header>
    </div>
  );
}

export default App;
